import { Component } from '@angular/core';

import { MessengerEmailComponent } from '../messages/messenger/messenger.email.component';

@Component({
  selector   : 'customer-payment-email-receipt',
  template: require('./customer-payment.email-receipt.component.html')
})
export class CustomerPaymentEmailReceiptComponent extends MessengerEmailComponent {}
